import { setUseWhatChange } from '@simbathesailor/use-what-changed';
import { useSelector } from 'react-redux';

import { PageTitle } from 'components/PageTitle';

import CopyAnalyticsDrawer from 'modules/common/drawers/copyAnalyticsDrawer/CopyAnalyticsDrawer';
import { FeatureFlagDrawer } from 'modules/common/drawers/featureFlagDrawer/FeatureFlagDrawer';
import CreateManagedIntegrationDrawer from 'modules/common/drawers/managedIntegrationCreateEditDrawer/ManagedIntegrationCreateEditDrawer';
import { NestingDefaultsDrawer } from 'modules/common/drawers/nestingDefaultsDrawer';
import InviteModal from 'modules/common/modals/inviteModal/InviteModal';
import SesVerificationFailureModal from 'modules/common/modals/sesVerificationFailureModal/SesVerificationFailureModal';
import { UploadDetailsModal } from 'modules/common/modals/uploadDetailsModal/UploadDetailsModal';
import LastActiveUserGroupModal from 'modules/common/userGroupManagement/lastActiveUserGroupModal/LastActiveUserGroupModal';
import SuperUserChangeUserGroupModal from 'modules/common/userGroupManagement/superUserChangeUserGroupModal/SuperUserChangeUserGroupModal';
import { DashboardViewProvider } from 'modules/dashboard/DashboardViewContext';
import FacilitateOrderDrawer from 'modules/quotes/quoteDetailsPage/modals/FacilitateOrderDrawer/FacilitateOrderDrawer';

import { isLoaded as getIsLoaded } from 'store/app/selectors';

import { UserGroupCollectionProvider } from 'utils/multisite';

import TermsAcceptanceModal from './TermsAcceptanceModal/TermsAcceptanceModal';
import useTokenManagementHook from './useTokenManagementHook';

const App = ({ children }) => {
  const isLoaded = useSelector(getIsLoaded);
  useTokenManagementHook();
  setUseWhatChange(process.env.NODE_ENV === 'development');

  if (!isLoaded) return null;
  return (
    <UserGroupCollectionProvider>
      <DashboardViewProvider>
        <PageTitle titleTemplate="%s • Paperless Parts" />
        <CopyAnalyticsDrawer />
        <CreateManagedIntegrationDrawer />
        <FeatureFlagDrawer />
        <InviteModal />
        <LastActiveUserGroupModal />
        <SesVerificationFailureModal />
        <SuperUserChangeUserGroupModal />
        <TermsAcceptanceModal />
        <UploadDetailsModal />
        <NestingDefaultsDrawer />
        <FacilitateOrderDrawer />
        {children}
      </DashboardViewProvider>
    </UserGroupCollectionProvider>
  );
};

export default App;
